<template>
    <div v-show="!this.loaded" class="text-center">
        <v-overlay :value="overlay">
            <v-progress-circular
            indeterminate
            size="64"
            ></v-progress-circular>
            <div>Buscando pedido...</div>
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: {
        loaded: {
            type    : Boolean,
        },
        overlay: {
            type    : Boolean,
        },

    },
}
</script>

<style>

</style>